import React from "react";
import EpisodesPage from "../catalogue/EpisodesPage";
import {
  deletePodcastEpisode,
  getPodcast,
  getPodcastEpisode,
  getPodcastEpisodeList,
  getPodcastSeasonList,
  updatePodcastEpisode,
  updatePodcastEpisodeMedia,
} from "../../../services/podcasts";
import { createPodcastEpisodeGeneralContent } from "../../../store/actions/uploadMediaAction";

/** Podcast episodes are tagged for the free or paid RSS feed. */
const rssTag = (podcast) => [
  podcast?.content_type === "free" ? "free-rss" : "paid-rss",
];

const PodcastEpisodeList = () => (
  <EpisodesPage
    idParam="podcast_id"
    loadSeries={getPodcast}
    loadSeasons={getPodcastSeasonList}
    loadEpisodes={getPodcastEpisodeList}
    loadEpisode={getPodcastEpisode}
    create={createPodcastEpisodeGeneralContent}
    update={updatePodcastEpisode}
    remove={deletePodcastEpisode}
    linkMedia={updatePodcastEpisodeMedia}
    tagType="podcast"
    section="podcasts"
    extraJwTags={rssTag}
    pricing={false}
    seriesPath={(id) => `/dashboard/update-podcast/${id}`}
    infoPath={(id) => `/dashboard/podcast-episode-info/${id}`}
    texts={{ noSeasons: "Please Add Seasons to the Podcast First!", editSeries: "Edit Podcast" }}
  />
);

export default PodcastEpisodeList;
